<template>
  <div id="event_modal" class="font-c3x6" v-show="showEventModal">
    <div class="overlay d-grid">
      <div class="box gray">
        <div class="box white text-center">
          <img
            style="
              position: absolute;
              top: -87px;
              transform: translateX(-50%);
              width: 140px;
              left: 50%;
            "
            :src="`${$s3}/img/common/map/map_event.png?${$ver}`"
          />
          <div class="font-w700">주말 보너스 이벤트</div>
          <div class="font-s14 mt-3">
            <div>주말에 오픈메타시티에 접속만 해도</div>
            <div class="mt-1">
              청약쿠폰
              <span class="font-w600" style="color: #0a57d4">10장</span>이 추가로 지급됩니다!
            </div>
          </div>
          <div class="font-s12 font-c6x6 mt-2">
            * 받은 청약쿠폰은 알림 내역에서 확인하실 수 있습니다.
          </div>
          <div class="font-s14 font-c6x6 mt-3">
            기간 :
            <span class="font-c3x6 font-w700">5월의 매주 토요일, 일요일</span>
          </div>
          <div class="font-s12 font-c6x6 mt-2">(7일, 8일, 14일, 15일 ,21일, 22일, 28일, 29일)</div>
        </div>
        <b-button @click="hideModal" variant="primary" style="margin-top: 8.5px"> 확인 </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EventModal',
  props: {},
  mounted() {},
  created() {},
  data() {
    return {};
  },
  computed: {
    showEventModal() {
      return this.$store.state.showEventModal;
    },
  },
  methods: {
    hideModal() {
      this.$store.commit('toggleEventModalMobile');
    },
  },
};
</script>

<style lang="scss">
@keyframes open_guide_modal {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

#event_modal {
  animation: open_guide_modal 0.2s;
  width: 100%;
  height: calc(calc(var(--vh, 1vh) * 100) - 80px);
  position: fixed;
  left: 0;
  right: 0;
  z-index: 3;

  .overlay {
    @extend #event_modal;
    align-items: center;
    justify-items: center;
    background-color: rgba(0, 0, 0, 0.3);

    @media screen and (max-width: 1119px) {
      background-color: rgba(0, 0, 0, 0.6);
    }

    .box {
      box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
      border-radius: 5px;

      &.gray {
        width: 320px;
        max-height: 366px;
        padding: 30px 8px 8.5px;
        background: #f5f5f5;
      }

      &.white {
        width: 100%;
        height: 100%;
        padding: 20px;
        background: #fff;
        position: relative;
      }
    }
  }
}
</style>
